import { render, staticRenderFns } from "./projectMien.vue?vue&type=template&id=5bced9ee&scoped=true&"
import script from "./projectMien.vue?vue&type=script&lang=js&"
export * from "./projectMien.vue?vue&type=script&lang=js&"
import style0 from "./projectMien.vue?vue&type=style&index=0&id=5bced9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bced9ee",
  null
  
)

export default component.exports